import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { BadgeScore } from '#src/app/shared/components/badges';

type Props = { score: number };
export const PetitionStrengthCard: React.FC<Props> = ({ score }) => {
	return (
		<div className="bg-background-base rounded-medium flex h-full min-w-[200px] flex-col gap-4 p-6">
			{/* Announced as its own screen-reader stop ("Petition strength"); the badge then announces "Score: N out of 10" and the rating follows — three clean stops, no repeated words. */}
			<Text as="p" size="small" fontWeight="bold" className="whitespace-nowrap">
				<Translate value="corgi.petition.details.strength_score.title" />
			</Text>
			<BadgeScore score={score} smallText announceScoreLabel />
		</div>
	);
};
